<div class="question-block">
  <span class="text-bold">{{ question() }}</span>
  <div class="answer-container flex-content">
    @for (answer of answers(); track answer.id) {
      <div class="status-bullet status-{{ answer.status }}">
        @if (answer.type === 'date') {
          <span class="text-normal">{{ answer.text | date: 'dd/MM/yyyy' }}</span>
        } @else if (answer.type === 'date_hidden') {
          <div class="text-container flex-content">
            <span class="text-icon">{{ answer.text }}
              @if (answer.tooltipText) {
                <svg infoIcon tooltip="{{ answer.tooltipText }}" size="20px"></svg>
              }
            </span>
            @if (answer.additionalDetails) {
              <span class="text-normal">{{ answer.additionalDetails }}</span>
            }
          </div>
        }@else {
          <div class="text-container ">
            <span class="text-normal">{{ answer.text }}</span>
            @if (answer.additionalDetails) {
              <span class="text-normal">{{ answer.additionalDetails }}</span>
            }
          </div>
        }
      </div>
    }
  </div>
</div>